import user from "./user";
const tpo = [
  {
    path: 'index',
    name: 'GRE首页',
    component: resolve => require(['@/view/gre/home/Index'], resolve),
    title: 'GRE首页',
  },
  {
    path: 'disclosed/exam',
    name: '套题模考',
    component: resolve => require(['@/view/gre/disclosed/exam'], resolve),
    meta: {
      title: '知学君',
      requireAuth: true
    }

  },
  {
    path: 'disclosed/verbal',
    name: 'verbal',
    component: resolve => require(['@/view/gre/disclosed/verbal'], resolve),
    meta: {
      title: '知学君',
      requireAuth: true
    }
  },

  {
    path: 'disclosed/quantitative',
    name: '公开数学',
    component: resolve => require(['@/view/gre/disclosed/quantitative'], resolve),
    meta: {
      title: '公开题数学',
      requireAuth: true
    }
  },
  {
    path: 'tpo/listening',
    name: 'TPO听力',
    component: resolve => require(['@/view/toefl/tpo/listening'], resolve),
    meta: {
      title: '知学君',
      requireAuth: true
    }
  },
   {
    path: 'undisclosed/exam',
    name: '在考真题套题模考',
    component: resolve => require(['@/view/gre/undisclosed/exam'], resolve),
    meta: {
      title: '在考真题套题模考',
      requireAuth: true
    }

  },
  {
    path: 'undisclosed/verbal',
    name: '在考真题-语文',
    component: resolve => require(['@/view/gre/undisclosed/verbal'], resolve),
    meta: {
      title: '语文',
      requireAuth: true
    }

  },
  {
    path: 'undisclosed/quantitative',
    name: '真题数学',
    component: resolve => require(['@/view/gre/undisclosed/quantitative'], resolve),
    meta: {
      title: '真题数学',
      requireAuth: true
    }
  },
  {
    path: 'undisclosed/speaking',
    name: '口语真题',
    component: resolve => require(['@/view/toefl/undisclosed/speaking'], resolve),
    meta: {
      title: '知学君',
      requireAuth: true
    }
  },
  {
    path: 'disclosed/writing',
    name: '写作',
    component: resolve => require(['@/view/gre/disclosed/writing'], resolve),
    meta: {
      title: '知学君',
      requireAuth: true
    }
  },
  {
    path: 'testReport',
    name: '测试报告',
    component: resolve => require(['@/view/toefl/testReport/index'], resolve),
    meta: {
      title: '知学君',
      requireAuth: true
    }
  },
  {
    path: 'browse',
    name: '浏览试题',
    component: resolve => require(['@/view/toefl/browse/index'], resolve),
    meta: {
      title: '知学君',
      requireAuth: true
    }
  },
  {
    path: 'search',
    name: '搜索',
    component: resolve => require(['@/view/gre/search/index'], resolve),
    meta: {
      title: '知学君',
      requireAuth: true
    }
  },
  {
    path: 'detail/reading',
    name: '阅读练习',
    component: resolve => require(['@/view/toefl/detail/reading'], resolve),
    meta: {
      title: '知学君',
      requireAuth: true
    }
  },
  {
    path: 'detail/writing',
    name: '写作练习',
    component: resolve => require(['@/view/toefl/detail/writing'], resolve),
    meta: {
      title: '知学君',
      requireAuth: true
    }
  },
  {
    path: 'detail/listening',
    name: '听力练习',
    component: resolve => require(['@/view/toefl/detail/listening'], resolve),
    meta: {
      title: '知学君',
      requireAuth: true
    }
  },
  {
    path: 'detail/speaking',
    name: '口语练习',
    component: resolve => require(['@/view/toefl/detail/speaking'], resolve),
    meta: {
      title: '知学君',
      requireAuth: true
    }
  },
  {
    path: 'user',
    redirect: 'user/profile/Home',
    component: resolve => require(['@/view/toefl/user/Index'], resolve),
    children: user
  },
 
  
]
export default tpo;


// WEBPACK FOOTER //
// ./src/router/gre/gre.js